
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 10.8a4.8 4.8 0 110-9.6 4.8 4.8 0 010 9.6zM1.4 22.8v-1.2a7.2 7.2 0 017.2-7.2h4.8a7.2 7.2 0 017.2 7.2v1.2"}})])
          )
        }
      }
    